import { render, staticRenderFns } from "./PrintingCard.vue?vue&type=template&id=83b72152&"
import script from "./PrintingCard.vue?vue&type=script&lang=js&"
export * from "./PrintingCard.vue?vue&type=script&lang=js&"
import style0 from "./PrintingCard.vue?vue&type=style&index=0&id=83b72152&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports